
import { useState, useEffect } from "react";
import { useAuth } from "@/context/AuthContext";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "@/hooks/use-toast";
import { 
  Card, CardContent, CardHeader, CardTitle, CardDescription 
} from "@/components/ui/card";
import { GroceryList } from "@/components/GroceryList";

export function GroceryListTab() {
  const { user } = useAuth();
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    // Set loading to false after component mounts to ensure GroceryList handles its own loading state
    setIsLoading(false);
  }, []);

  if (error) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>My Grocery List</CardTitle>
          <CardDescription>An error occurred: {error}</CardDescription>
        </CardHeader>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>My Grocery List</CardTitle>
        <CardDescription>Manage all your grocery shopping items in one place</CardDescription>
      </CardHeader>
      
      <CardContent>
        <GroceryList title="My Grocery List" />
      </CardContent>
    </Card>
  );
}
